import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMailchimpRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#mailchimp-regular-clip)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fill: "#fddd4c",
				d: "M16 .5a15.5 15.5 0 1 0 0 31 15.5 15.5 0 0 0 0-31"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#000",
				d: "M9.2 20c-.3-.5.5-1.2.2-1.9q-.3-.6-1-.7a1 1 0 0 0-1 .4q-.5.8-.3 1.2v.1c.3 0 .4-.5.5-.6q.3-.5 1-.2c.6.4 0 1 0 1.5q.3.8.7.8.5 0 .6-.3c0-.3-.4.2-.7-.3m12.6-4.7h-.5l-.3-.7q-.2-1 .2-1.1.5 0 .6.9zm-3.7.3v.4l.6.2v.1H18q-.1.4-.5.1-.1.2-.4 0l.2-.2-.2-.7-.5.2h-.4l.3-.4.6-.3q0-.5.3-.6.4 0 .5.6.6.2.9.6v.2zm2.2 1.4.5-.1q.1-.3-.2-.5-.5-.2-.5.1-.1.3.2.5m1-.8q0-.3.4-.4.3 0 .3.4t-.3.4-.3-.4"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#000",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M26.2 19.2c.3 0 .9.4.9 1.4q-.2 1.7-.5 2.3c-1.5 3.5-5 5.4-9.1 5.3a9 9 0 0 1-8.7-5.4q-1.3 0-2.4-1A4 4 0 0 1 5 19.5a4 4 0 0 1 .3-1.8l-.9-.7C.8 13.9 12.5 1 16.2 4.3l1.2 1.3c1.8-.8 6.6-2.2 6.6 1.1q0 1.7-1.8 3.6c1.3 1.2 1 2.9 1.2 4.5l.4.1q1.3.4 1.8.9t.5 1-.3 1.3zM8.8 22h.4c1.3-.3 1.7-1.8 1.5-3.2-.3-1.6-1.4-2.2-2.2-2.2H8q-2.1.6-2 2.9c.2 1.3 1.5 2.4 2.8 2.5m-3-5q.6-.9 2-1.2 1.6-4.4 5.1-7.2L16.6 6s-1-1.2-1.4-1.2c-1.8-.5-5.9 2.2-8.5 5.9-1 1.5-2.5 4-1.8 5.4 0 .2.6.6.8.8M21 21.2s-1.6.8-4 0c.1.8 1 1 1.6 1.1 3 .5 5.7-1.1 6.4-1.6v.2c-.8 1-2.9 2-5.6 2-1.1 0-2.3-.3-2.7-1-.7-1 0-2.3 1-2.2q3 .3 5.6-.7 2.1-1.1 2-2.1c-.2-1-1.6-1.1-2.3-1.3q-.5 0-.5-.8v-1.5c0-.6-.2-1.5-.7-1.9l-.5-.1h-.2q-.5 0-.8.4-1 .8-1.9.6h-1.5c-1.1-.1-2.3.8-2.5 2-.2 1.5.6 2.4 1.2 3l.3.4.1.2-.1.3a5 5 0 0 0-1 4.4l.1.5c1 2.2 4 3.3 7 2.3 2-.6 3.8-2.2 4.2-4.5q0-.7-.2-.9h-.4l-.4-1.4q-1.5 1-2.8 1.4-2.1.6-4.2.4-1-.3-1.1.4c1.8.6 3.8.3 3.8.3zm-5.3-13q-1.6.8-3 2.5A10 10 0 0 1 20 9.3v-.1q-1-.6-2.2-.6 0-.3.4-.5c-.9 0-2.8.9-2.8.8z"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "mailchimp-regular-clip",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h32v32H0z"
		})
	}) })]
});
export default SvgMailchimpRegularIcon;
